import { Link as RouterLink } from 'react-router-dom'

import { T } from '@tribeplatform/react-components/i18n'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export const MessagingSettings = () => {
  return (
    <Dropdown>
      <Dropdown.ButtonMinimal>
        <SvgIcon name="dots-horizontal" />
      </Dropdown.ButtonMinimal>
      <Dropdown.Items>
        <Dropdown.Item
          leadingIcon={<SvgIcon name="forbidden" />}
          as={RouterLink}
          to="/messaging/settings/blocked"
        >
          <T
            defaultMessage="Blocked {MEMBERS}"
            id="Messaging.Settings.BlockedMembers"
          />
        </Dropdown.Item>
        <Dropdown.Item
          leadingIcon={<SvgIcon name="cog" />}
          as={RouterLink}
          to="/messaging/settings"
        >
          <T defaultMessage="Settings" id="Generics.Settings" />
        </Dropdown.Item>
      </Dropdown.Items>
    </Dropdown>
  )
}
